import { Reveal } from '@/components/Reveal/Reveal';
import { Section } from '@/components/Section/Section';
import { DEPARTMENT_ORDER, DEPARTMENTS } from '@/dictionary/departments';
import { HOME_DEPARTMENTS } from '@/dictionary/home';
import { departmentPath, HOME_ANCHORS } from '@/dictionary/routes';
import classes from './DepartmentsSection.module.css';

/* כרטיסי המחלקות נפתחים בלשונית חדשה, בהתאם להתנהגות באתר המקורי.
   אין וידאו רקע בסקשן הזה — כך גם באתר המקורי. */
export function DepartmentsSection() {
  return (
    <Section id={HOME_ANCHORS.departments.slice(1)}>
      <Reveal>
        <div className={classes.head}>
          <p className={classes.kicker}>{HOME_DEPARTMENTS.kicker}</p>
          <h2 className={classes.title}>
            {HOME_DEPARTMENTS.titleLead}{' '}
            <span className={classes.thin}>{HOME_DEPARTMENTS.titleThin}</span>
          </h2>
          <p className={classes.lead}>{HOME_DEPARTMENTS.lead}</p>
        </div>
      </Reveal>

      <div className={classes.grid}>
        {DEPARTMENT_ORDER.map((slug, index) => {
          const department = DEPARTMENTS[slug];
          const content = (
            <>
              <div className={classes.cardIcon}>
                <img src={`/assets/icon-${slug}.png`} alt="" />
              </div>
              <h3 className={classes.cardTitle}>{department.title}</h3>
            </>
          );

          return (
            <Reveal key={slug} delaySeconds={index * 0.06}>
              {/* קישור רגיל ולא Link של הראוטר: הכרטיסים נפתחים בלשונית חדשה
                  כפי שבאתר המקורי, ושם לניווט של הראוטר אין ממילא יתרון */}
              <a
                href={department.externalUrl ?? departmentPath(slug)}
                target="_blank"
                rel="noopener noreferrer"
                className={classes.card}
              >
                {content}
              </a>
            </Reveal>
          );
        })}
      </div>
    </Section>
  );
}
